
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const { profile } = useAuth();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Determine the home route based on user role
  const getHomeRoute = () => {
    if (!profile) return "/";
    return profile.role === "admin" ? "/admin/dashboard" : "/author/dashboard";
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center max-w-md mx-auto p-6">
        <h1 className="text-6xl font-bold text-royalty-600 dark:text-royalty-400 mb-4">404</h1>
        <p className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-2">Page Not Found</p>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Sorry, we couldn't find the page you're looking for.
        </p>
        <Button asChild className="inline-flex items-center">
          <Link to={getHomeRoute()}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Return to Dashboard
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
